import React from 'react';
import styled, { css } from 'styled-components/macro';
import { themeGetCss } from '@blueprint/ui';

import Text from '../Typography';

export const LabelBox = styled(Text)(
  themeGetCss('nativeDropdown.selectTitle'),
  css`
    position: absolute;
    pointer-events: none;

    &.disabled {
      cursor: not-allowed;
      opacity: 0.3;
    }
  `,
);

const SelectTitle = ({ children, ...rest }) => {
  return <LabelBox {...rest}>{children}</LabelBox>;
};

SelectTitle.displayName = 'SelectTitle';

export default SelectTitle;
